if (typeof SingleItemSlider === "undefined") {

    var SingleItemSlider = (function($) {

        var ret = {},
            doc,
            gallery, sliders, slickList, isMobile = false,
            disableInlineVideo = true;

        function ready() {
            doc = $(document);
            doc.on("click", ".single-item-slider .slick-slide", onSlideClick);
            isMobile = $("body").hasClass("mobile-device");
            gallery = $(".single-item-slider");
            sliders = gallery.children(".images");
            setupSliders();
        }

        function slickInit(slick) {
					var h3 = $(this).find('h3').first();
					var slickTrack = $(this).find('.slick-track');
					if (h3.length > 0 && h3.attr('id')) {
						slickTrack.attr('aria-labelledby', h3.attr('id'));
					}
				}

        function setupSliders() {
            gallery.each(function(i, el) {
                var gallery = $(this);
                var slider = gallery.find(".images");
                slider.on("init",
                    function (slick) {
                        slickList = slider.find(".slick-list");
                        var firstItem = gallery.find("[data-slick-index=0]");
                        gallery.children("h3").detach().prependTo(firstItem);
                        gallery.children("p").detach().appendTo(firstItem);
                        slickInit.apply(this, arguments);
                    });
                slider.on("afterInit", window.SlickSettings.slickAfterInit);
                slider.on("beforeChange",
                    function (event, slick, currentSlide, nextSlide) {
                        if (disableInlineVideo) {
                            return;
                        }
                        var slides = $("iframe");
                        pauseVideo(slides);
                    });
            });
            sliders.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                prevArrow: '<span class="prev icon-chevron-left-circle slick-arrow"></span>',
                nextArrow: '<span class="next icon-chevron-right-circle slick-arrow"></span>'
            });
        }

        function pauseVideo(slides) {
            var data = { "event": "command", "func": "pauseVideo", "args": "" };
            var message = JSON.stringify(data);
            slides.each(function() {
                this.contentWindow.postMessage(message, "*");
            });
        }

        function playVideo(slides) {
            var data = { "event": "command", "func": "playVideo", "args": "" };
            var message = JSON.stringify(data);
            slides.each(function() {
                this.contentWindow.postMessage(message, "*");
            });
        }

        function onSlideClick(e) {
            if (disableInlineVideo) {
                return;
            }
            var me = $(e.currentTarget);
            e.preventDefault();
            if (isMobile && me.hasClass("video")) {
                // Play the video inline
                me.children(".video-container").remove();
                var videoEmbedUrl = me.attr('data-video-embed-url');
                if (!videoEmbedUrl) {
                    return;
                }
                me.append(videoEmbed(videoEmbedUrl));
                var iframe = me.find("iframe");
                iframe.on("load",
                    function() {
                        playVideo(iframe);
                    });
            }
        }

        function videoEmbed(src) {
            src = enableJsApi(src);
            var vid =
                $('<div class="video-container"><iframe width="809" height="455" src="' + src + '" frameborder="0" allowfullscreen></iframe></div>');
            return vid;
        }

        var enableJsApiPattern = /([\?&]enablejsapi)=/i;

        function enableJsApi(youtubeUrl) {
            if (enableJsApiPattern.test(youtubeUrl)) {
                return youtubeUrl.replace(enableJsApiPattern, '$1=1')
            }
            else {
                return youtubeUrl + (youtubeUrl.indexOf('?') >= 0 ? '&' : '?') + 'enablejsapi=1';
            }
        }

        $(ready);

        Object.defineProperty(ret, 'disableInlineVideo', {
            get: function() {
                return disableInlineVideo;
            },
            set: function(val) {
                disableInlineVideo = !!val;
            }
        });

        return ret;

    })(jQuery);
}